import WeatherWidgetDotOrgWeatherWidget from "./WeatherWidgetDotOrgWeatherWidget";
import OpenWeatherMapWeatherWidget from "./OpenWeatherMapWeatherWidget";
import {WEATHER_WIDGET_PROVIDERS} from "../../utils/constants";

const WeatherWidget = ({ selectedFleet, "data-testid": dataTestId = "weather-widget" }) => {
  if (selectedFleet){
    if (!selectedFleet.weatherWidgetProvider || selectedFleet.weatherWidgetProvider === WEATHER_WIDGET_PROVIDERS.WEATHER_WIDGET_DOT_ORG) {
        // deprecated
        return <WeatherWidgetDotOrgWeatherWidget selectedFleet={selectedFleet} data-testid={dataTestId} />;
    } else if (selectedFleet.weatherWidgetProvider === WEATHER_WIDGET_PROVIDERS.OPEN_WEATHER_MAP) {
        return <OpenWeatherMapWeatherWidget selectedFleet={selectedFleet} data-testid={dataTestId} />
    } else {
        console.error("Unknown weather widget provider:", selectedFleet.weatherWidgetProvider);
        return null
    }
  }
  return null;
}

export default WeatherWidget;
